import { jsx as a } from "react/jsx-runtime";
const s = ({ children: e }) => /* @__PURE__ */ a("div", { className: "flex gap-5 items-center overflow-x-auto p-3", children: e });
export {
  s as default
};
